// @ts-check
import React, { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import axios from "axios";
import Card from "./components/Card";
import Toolbar from "./components/Toolbar";
import Header from "./components/Header";

const App = () => {
  const [beaches, setBeaches] = useState([]);
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem("favorites");
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });
  const [showFavorites, setShowFavorites] = useState(() => {
    const savedShowFavorites = localStorage.getItem("showFavorites");
    return savedShowFavorites ? JSON.parse(savedShowFavorites) : false;
  });
  const [sortOrder, setSortOrder] = useState(() => {
    const savedSortOrder = localStorage.getItem("sortOrder");
    return savedSortOrder ? savedSortOrder : "lastUpdated";
  });
  const [showToast, setShowToast] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Mock API call to fetch beaches data
    const fetchData = async () => {
      try {
        const result = await axios.get("/api/proxy");
        setBeaches(result.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleFavorite = (beachName) => {
    const updatedFavorites = favorites.includes(beachName)
      ? favorites.filter((name) => name !== beachName)
      : [...favorites, beachName];
    if (favorites.length === 0 && updatedFavorites.length === 1) {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
    setFavorites(updatedFavorites);
    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
  };

  const toggleShowFavorites = () => {
    const updatedShowFavorites = !showFavorites;
    setShowFavorites(updatedShowFavorites);
    localStorage.setItem("showFavorites", JSON.stringify(updatedShowFavorites));
  };

  const handleSortChange = (event) => {
    const newSortOrder = event.target.value;
    setSortOrder(newSortOrder);
    localStorage.setItem("sortOrder", newSortOrder);
  };

  const sortBeaches = (/** @type {any[]} */ beaches) => {
    return beaches.sort((a, b) => {
      switch (sortOrder) {
        case "highest":
          return b.temperature - a.temperature;
        case "lowest":
          return a.temperature - b.temperature;
        case "alphabetical":
          return a.name.localeCompare(b.name);
        case "lastUpdated":
          return (
            new Date(b.temp_time).getTime() - new Date(a.temp_time).getTime()
          );
        default:
          return 0;
      }
    });
  };

  const displayedBeaches = showFavorites
    ? // @ts-ignore
      sortBeaches(beaches.filter((beach) => favorites.includes(beach.name)))
    : sortBeaches(beaches);

  return (
    <div className="App text-center">
      {showToast && (
        <div className="toast fixed top-0 left-1/2 transform -translate-x-1/2 bg-blue-400 text-white p-2 rounded m-3">
          Suosikit lista luotu.
        </div>
      )}
      <Header isLoading={isLoading} />
      <Toolbar
        showFavorites={showFavorites}
        toggleShowFavorites={toggleShowFavorites}
        sortOrder={sortOrder}
        handleSortChange={handleSortChange}
      />
      <main className="px-2">
        {showFavorites && displayedBeaches.length === 0 ? (
          <p className="py-4">
            Voit lisätä kohteen suosikiksi klikkaamalla sydäntä.
          </p>
        ) : (
          displayedBeaches.map((beach) => (
            <Card
              key={beach.name}
              beach={beach}
              toggleFavorite={toggleFavorite}
              favorites={favorites}
            />
          ))
        )}
      </main>
      <footer className="p-4 text-[#777]">
        <p>
          Lähde:{" "}
          <a
            href="https://tampere.sometec.fi/index.html?sP409100P600P#pageResult5"
            target="_blank"
            rel="noreferrer"
          >
            tampere.sometec.fi
          </a>
        </p>
        <p>
          <a
            href="https://www.reddit.com/r/Tampere/comments/1d3zqby/tampereen_j%C3%A4rvien_l%C3%A4mp%C3%B6tilat_sovellus/"
            target="_blank"
            rel="noreferrer"
          >
            Anna palautetta
          </a>
        </p>
      </footer>
      <Analytics />
    </div>
  );
};

export default App;
